module.exports = __webpack_public_path__ + "img/fj.132572c8.jpg";